module.exports = __webpack_public_path__ + "img/ddos.705aaf4.svg";